<template>
  <v-app id="inspire">
    <Header type="return"/>
    <v-main class="grey lighten-3">
      <v-container>
        <v-row>
          <Menu/>
          <v-container class="col-10">
            <v-row>
              <v-col class="page-top d-flex justify-space-between" cols="12">
                <div>
                  <div class="page-title">Сделки</div>
                  <div class="breadcrumb">Монитор продаж / Сделки</div>
                </div>
              </v-col>
            </v-row>
          </v-container>
        </v-row>
        <v-col>
          <v-sheet
              rounded="lg"
          >
            <v-card-title
                class="custom__card-title"
            >
              <div class="search_client">
                <v-text-field
                    v-model="search"
                    rounded
                    outlined
                    dense
                    hide-details
                    single-line
                    label="Поиск"
                    style="font-size: 12px;font-weight: normal"
                    background-color="white"
                >
                  <template v-slot:prepend-inner>
                    <v-icon>mdi-magnify</v-icon>
                  </template>
                </v-text-field>
              </div>
              <div class="filter_client">
                <v-btn
                    dark
                    class="filter-button"
                    :disabled="isLoading"
                    @click="dialogFiler = !dialogFiler"
                >
                  <img
                      class="mr-1"
                      src="/playground_assets/mediumfilter.svg"
                  >
                  Фильтр
                </v-btn>
              </div>

            </v-card-title>
            <v-card-text
                v-show="dialogFiler"
                v-if="list && list.monitor"
            >
              <v-container>
                  <v-row>
                    <v-col
                        cols="12"
                        sm="3"
                        md="3"
                    >
                      <label>Создана</label>
                      <VueDatePicker
                          @input="collectData"
                          no-title
                          no-header
                          range
                          rangeInputText="%d - %d"
                          format="DD MMMM"
                          color="#629f34"
                          v-model="dealsFilter.date_creation"
                          style="flex: none !important;"
                      >
                        <template #activator="{ date }">
                          <button
                              class="button custom__datepicker"
                              ref="activator"
                              type="button"
                          >
                            <div>
                              <span v-if="dealsFilter.date_creation">{{ date }}</span>
                              <span v-else style="color: gray">Выберите период</span>
                            </div>
                            <v-icon
                                medium
                                right
                                class="ml-5"
                            >
                              mdi-calendar-blank-outline
                            </v-icon>
                          </button>
                        </template>
                      </VueDatePicker>
                    </v-col>
                    <v-col
                        cols="12"
                        sm="3"
                        md="3"
                    >
                      <label>Завершена</label>
                      <VueDatePicker
                          @input="collectData"
                          no-title
                          no-header
                          range
                          rangeInputText="%d - %d"
                          format="DD MMMM"
                          color="#629f34"
                          v-model="dealsFilter.date_end"
                          style="flex: none !important;"
                      >
                        <template #activator="{ date }">
                          <button
                              class="button custom__datepicker"
                              ref="activator"
                              type="button"
                          >
                            <div>
                              <span v-if="dealsFilter.date_end">{{ date }}</span>
                              <span v-else style="color: gray">Выберите период</span>
                            </div>
                            <v-icon
                                medium
                                right
                                class="ml-5"
                            >
                              mdi-calendar-blank-outline
                            </v-icon>
                          </button>
                        </template>
                      </VueDatePicker>
                    </v-col>
                    <v-col
                        cols="12"
                        sm="3"
                        md="3"
                    >
                      <label>Запланированная задача</label>
                      <VueDatePicker
                          @input="collectData"
                          no-title
                          no-header
                          range
                          rangeInputText="%d - %d"
                          format="DD MMMM"
                          color="#629f34"
                          v-model="dealsFilter.date_schedule"
                          style="flex: none !important;"
                      >
                        <template #activator="{ date }">
                          <button
                              class="button custom__datepicker"
                              ref="activator"
                              type="button"
                          >
                            <div>
                              <span v-if="dealsFilter.date_schedule">{{ date }}</span>
                              <span v-else style="color: gray">Выберите период</span>
                            </div>
                            <v-icon
                                medium
                                right
                                class="ml-5"
                            >
                              mdi-calendar-blank-outline
                            </v-icon>
                          </button>
                        </template>
                      </VueDatePicker>
                    </v-col>
                    <v-col
                        cols="12"
                        sm="3"
                        md="3"
                    >
                      <label>Статус сделки</label>
                      <v-select
                          @input="collectData"
                          class="rounded-lg custom__select"
                          v-model="dealsFilter.status_deal"
                          :items="statusDealTypes"
                          item-value="value"
                          item-text="name"
                          :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                          placeholder="Значение" append-icon="mdi-chevron-down" outlined
                          dense
                      >
                      </v-select>
                    </v-col>
                    <v-col
                        cols="12"
                        sm="3"
                        md="3"
                    >
                      <label>Статус клиента</label>
                      <v-select
                          @input="collectData"
                          class="rounded-lg custom__select"
                          v-model="dealsFilter.status_client"
                          :items="statusClientTypes"
                          item-value="value"
                          item-text="name"
                          :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                          placeholder="Значение" append-icon="mdi-chevron-down" outlined
                          dense
                      >
                      </v-select>
                    </v-col>
                    <v-col
                        cols="12"
                        sm="3"
                        md="3"
                    >
                      <label>Клубы</label>
                      <v-select
                          @input="collectData"
                          class="rounded-lg custom__select"
                          v-model="dealsFilter.club"
                          :items="clubTypes"
                          item-value="id"
                          item-text="name"
                          :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                          placeholder="Значение" append-icon="mdi-chevron-down" outlined
                          dense
                      >
                      </v-select>
                    </v-col>
                    <!-- <v-col
                        cols="12"
                        sm="3"
                        md="3"
                    >
                      <label>Вид сделки</label>
                      <v-select
                          @input="collectData"
                          class="rounded-lg custom__select"
                          v-model="dealsFilter.type"
                          :items="stageTypes"
                          item-value="value"
                          item-text="name"
                          :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                          placeholder="Значение" append-icon="mdi-chevron-down" outlined
                          dense
                      >
                      </v-select>
                    </v-col> -->
                    <v-col
                        cols="12"
                        sm="3"
                        md="3"
                    >
                      <label>Этап</label>
                      <v-select
                          @input="collectData"
                          class="rounded-lg custom__select"
                          v-model="dealsFilter.current_stage"
                          :items="stageTypes"
                          item-value="value"
                          item-text="name"
                          :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                          placeholder="Значение" append-icon="mdi-chevron-down" outlined
                          dense
                      >
                      </v-select>
                    </v-col>
                    <v-col
                        cols="12"
                        sm="3"
                        md="3"
                    >
                      <label>Менеджер</label>
                      <!-- <v-select
                          @input="collectData"
                          class="rounded-lg custom__select"
                          v-model="dealsFilter.manager"
                          :items="list.monitor"
                          item-value="manager.id"
                          item-text="manager.name"
                          :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                          placeholder="Значение" append-icon="mdi-chevron-down" outlined
                          dense
                      >
                      </v-select> -->
                      
                    <v-select
                      v-if="managersList && managersList.managers"
                                v-model="dealsFilter.manager"
                                :items="managersList.managers"
                                no-data-text="Нет доступных менеджеров"
                                item-text="name"
                                item-value="id"
                                class="rounded-lg"
                                label="Выбрать"
                                append-icon="mdi-chevron-down"
                                outlined
                                dense
                                required
                                color="#629F33"
                                return-object
                            ></v-select>
                    </v-col>
                    <v-col
                        cols="12"
                        sm="3"
                        md="3"
                    >
                      <label>Кем создан</label>
                      <!-- <v-select
                          @input="collectData"
                          class="rounded-lg custom__select"
                          v-model="dealsFilter.user"
                          :items="list.monitor"
                          item-value="user.id"
                          item-text="user.name"
                          :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                          placeholder="Значение" append-icon="mdi-chevron-down" outlined
                          dense
                      >
                      </v-select> -->
                      <v-select
                      v-if="specialist && specialist.specialist"
                                v-model="dealsFilter.user"
                                :items="specialist.specialist"
                                no-data-text="Нет доступных менеджеров"
                                item-text="name"
                                item-value="id"
                                class="rounded-lg"
                                label="Выбрать"
                                append-icon="mdi-chevron-down"
                                outlined
                                dense
                                required
                                color="#629F33"
                                return-object
                            ></v-select>
                    </v-col>
                    <v-col
                        cols="12"
                        sm="3"
                        md="3"
                    >
                      <label>Источник</label>
                      <v-select
                          @input="collectData"
                          class="rounded-lg custom__select"
                          v-model="dealsFilter.advertising_source"
                          :items="sourceTypes"
                          item-value="value"
                          item-text="name"
                          :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                          placeholder="Значение" append-icon="mdi-chevron-down" outlined
                          dense
                      >
                      </v-select>
                    </v-col>
                    <v-col
                        cols="12"
                        sm="3"
                        md="3"
                    >
                      <label>Тег</label>
                      <v-select
                        v-if="tagsList && tagsList.length > 0"
                        @input="collectData"
                        class="rounded-lg custom__select"
                        v-model="dealsFilter.tag"
                        :items="tagsList"
                        item-value="id"
                        item-text="name"
                        :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                        placeholder="Значение" append-icon="mdi-chevron-down" outlined
                        dense
                    >
                    </v-select>
                    </v-col>
                    <v-col
                        cols="12"
                        sm="3"
                        md="3"
                    >
                      <label>Интерес</label>
                      <v-select
                          @input="collectData"
                          class="rounded-lg custom__select"
                          v-model="dealsFilter.interests"
                          :items="interestsTypes"
                          item-value="id"
                          item-text="name"
                          :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                          placeholder="Значение" append-icon="mdi-chevron-down" outlined
                          dense
                      >
                      </v-select>
                    </v-col>
                    <v-col
                        cols="12"
                        sm="3"
                        md="3"
                    >
                      <label>Задачи</label>
                      <v-select
                          @input="collectData"
                          class="rounded-lg custom__select"
                          v-model="dealsFilter.scheduled_task"
                          :items="scheduledTaskTypes"
                          item-value="value"
                          item-text="name"
                          :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                          placeholder="Значение" append-icon="mdi-chevron-down" outlined
                          dense
                      >
                      </v-select>
                    </v-col>
                    <v-col
                        cols="12"
                        sm="3"
                        md="3"
                    >
                      <label>Канал</label>
                      <v-select
                          @input="collectData"
                          class="rounded-lg custom__select"
                          v-model="dealsFilter.advertising_platform"
                          :items="platformTypes"
                          item-value="value"
                          item-text="name"
                          :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                          placeholder="Значение" append-icon="mdi-chevron-down" outlined
                          dense
                      >
                      </v-select>
                    </v-col>
                    <v-col
                        cols="12"
                        sm="3"
                        md="3"
                    >
                      <label>Пометка удаления</label>
                      <v-select
                          @input="collectData"
                          class="rounded-lg custom__select"
                          v-model="dealsFilter.deletion"
                          :items="deletionTypes"
                          item-value="value"
                          item-text="name"
                          :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                          placeholder="Значение" append-icon="mdi-chevron-down" outlined
                          dense
                      >
                      </v-select>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-card-actions class="mt-4">
                      <template v-if="!dialogButton">
                        <button
                            class="button custom__button mt-5"
                            type="button"
                            @click="returnDeals"
                        >
                          Применить
                        </button>
                      </template>
                      <template v-else>
                        <button
                            class="button custom__button mt-5"
                            type="button"
                            @click="filterDeals(dealsFilter)"
                            style="background-color: #A13453 !important;color: #fff !important;"
                        >
                          Применить
                        </button>
                        <button
                            class="button custom__button mt-5 ml-3"
                            type="button"
                            style="background-color: #D53025 !important;color: #fff !important; width: auto !important; padding: 5px 20px;"
                            @click="clearData"
                        >
                          Сбросить фильтр
                        </button>
                      </template>
                    </v-card-actions>
                  </v-row>
                </v-container>
            </v-card-text>
            <v-data-table
                v-if="list && list.monitor && !isLoading"
                    :headers="headersDeals"
                    :items="list.monitor"
                    no-data-text="Результатов не найдено"
                    :hide-default-footer="true"
                    :page="page"
                    class="elevation-1"
                    :server-items-length="list.monitor.listLength"
                    :items-per-page="toggle_exclusive"
            >
            <template v-slot:body="{ items, headers }">
                <tbody name="list" is="transition-group" v-if="items.length > 0">
                <tr v-for="item in items" :key="item.id">
                  <td>
                    <router-link
                        :to="{ name: 'CardClientNew', params: {client_id: item.client.id}}"
                        class="d-flex"
                        style="align-items: center; text-decoration: none; color: #000"
                    >
                      {{ item.client ? item.client.name : ''}}
                    </router-link>
                  </td>
                  <td>{{ item.name }}</td>
                  <td>{{ formatDate(item.date_creation) }}</td>
                  <td>{{ item.tag }}</td>
                  <td>{{ item.interests }}</td>
                  <td :style="'background-color: ' + item.current_stage.colour">{{ item.current_stage.name }}{{ item.sum > 0 ? ', ' + item.sum : '' }}{{ item.type.name ? ', ' + item.type.name : ''}}</td>
                  <td>{{ item.advertising_source ? item.advertising_source.name : ''}}{{ item.advertising_platform ? ', ' + item.advertising_platform.name : ''}}</td>
                  <td>{{ item.scheduled_task ? item.scheduled_task.name : '' }}</td>
                  <td>{{ item.manager ? item.manager.name : ''}}</td>
                  <td>{{ item.club ? item.club.name : ''}}</td>
                  <td>{{ item.user ? item.user.name : '' }}</td>
                  <td>{{ item.last_task ?  item.last_task.name : '' }}</td>
                  <td>{{ item.cancel_reason ? item.cancel_reason.name : ''}}</td>
                </tr>
                </tbody>
                <tbody v-else>
                <tr class="v-data-table__empty-wrapper">
                  <td :colspan="headers.length">Потенциальных клиентов не найдено</td>
                </tr>
                </tbody>
              </template>
            </v-data-table>
            <!-- <v-card-actions
                class="d-flex justify-content-between"
                style="padding: 20px !important;"
            >
              <template>
                <div></div>
                <div>
                  <v-pagination
                      v-model="page"
                      circle
                      color="#629F33"
                      :length="Math.ceil(list.monitor.length / 10)"
                  ></v-pagination>
                </div>
              </template>
            </v-card-actions> -->
            <v-card-actions
                      class="d-flex justify-content-between"
                      style="padding: 20px !important;"
                  >
                    <template v-if="list && list.listLength">
                      <div>
                        <span class="desktopRegularLabel"><span>Показано с 1 по {{ toggle_exclusive }} из {{ list.listLength }} результатов</span></span>
                      </div>
                      <div>
                        <v-pagination
                            v-model="page"
                            circle
                            color="#629F33"
                            :length="list.paginationLength"
                            :total-visible="8"
                        ></v-pagination>
                      </div>
                    </template>
                  </v-card-actions>
          </v-sheet>

        </v-col>
      </v-container>
    </v-main>
  </v-app>
</template>
<script>
import {VueDatePicker} from '@mathieustan/vue-datepicker';
import '@mathieustan/vue-datepicker/dist/vue-datepicker.min.css';
import {getItem} from '@/helpers/persistanceStorage';
import {setItem} from '@/helpers/persistanceStorage';
import {monitorActionTypes} from "@/store/modules/monitor";
import Header from '@/components/Header.vue';
import Menu from '@/components/Menu.vue';
import {mapState} from "vuex";
import {advertisingActionTypes} from "@/store/modules/advertising";
import {organizationActionTypes} from '@/store/modules/organization';
import {lessonActionTypes} from "@/store/modules/lesson";
import {tagsActionTypes} from '@/store/modules/tags';

export default {
  name: 'Transactions',
  props: ['specialistType', 'specialist_id', 'type','startdate','enddate','specialist_ids'],
  components: {
    VueDatePicker,
    Header,
    Menu,
  },
  computed: {
    ...mapState({
      isLoading: state => state.monitor.isLoading,
      list: state => state.monitor.list,
      validationErrors: state => state.monitor.validationErrors,
      listPlatforms: state => state.advertising.listPlatforms,
      listSources: state => state.advertising.listSources,
      managersList: state => state.organization.managersList,
      specialist: state => state.lesson.specialist
    })
  },
  methods: {
    fetchFeed(specialist_id, type, startdate, enddate, search, filter) {
      
      let page = this.page
      let limit = this.toggle_exclusive

      let client_search = search ? search : null
      let deal_filter = filter ? filter : null

      setItem('transactions-filter_obj', JSON.stringify(deal_filter))
      
      if (type === 'notask') {
        this.$store.dispatch(monitorActionTypes.getNotaskDeals, {
          specialist_id,
          startdate,
          enddate,
          page,
          limit,
          client_search,
          deal_filter
        })
      } else {
        this.$store.dispatch(monitorActionTypes.getActiveDeals, {
          specialist_id,
          startdate,
          enddate,
          page,
          limit,
          client_search,
          deal_filter
        })
      }
    },
    collectData(selected) {
      this.selected.push(selected)
      if (this.selected === []) {
        this.dialogButton = false;
      }
    },
    clearData() {
      this.selected.length = 0;
      this.dealsFilter.date_creation = null;
      this.dealsFilter.date_end = null;
      this.dealsFilter.date_schedule = null;
      this.dealsFilter.status_deal = null;
      this.dealsFilter.status_client = null;
      this.dealsFilter.club = null;
      this.dealsFilter.type = null;
      this.dealsFilter.current_stage = null;
      this.dealsFilter.manager = null;
      this.dealsFilter.user = null;
      this.dealsFilter.advertising_source = null;
      this.dealsFilter.tag = null;
      this.dealsFilter.interests = null;
      this.dealsFilter.scheduled_task = null;
      this.dealsFilter.advertising_platform = null;
      this.dealsFilter.deletion = null;
      this.dialogButton = true;
    },
    filterDeals(deals) {
      console.log(deals)
      this.fetchFeed(this.specialist_id, this.type, this.startdate, this.enddate, this.search, this.dealsFilter);
      // if (deals.date_creation !== null) {
      //   this.list.monitor = this.list.monitor.filter((item) => new Date(deals.date_creation.start) <= new Date(item.date_creation) && new Date(item.date_creation) <= new Date(deals.date_creation.end));
      // }
      // if (deals.date_end !== null) {
      //   this.list.monitor = this.list.monitor.filter((item) => new Date(deals.date_end.start) <= new Date(item.date_end) && new Date(item.date_end) <= new Date(deals.date_end.end));
      // }
      // if (deals.date_schedule !== null) {
      //   this.list.monitor = this.list.monitor.filter((item) => new Date(deals.date_schedule.start) <= new Date(item.scheduled_task.date) && new Date(item.scheduled_task.date) <= new Date(deals.date_schedule.end));
      // }
      // if (deals.status_deal !== null) {
      //   this.list.monitor = this.list.monitor.filter((item) => (item.date_end !== "") === deals.status_deal);
      // }
      // if (deals.status_client !== null) {
      //   this.list.monitor = this.list.monitor.filter((item) => item.client.status === deals.status_client);
      // }
      // if (deals.club !== null) {
      //   this.list.monitor = this.list.monitor.filter((item) => item.club.id === deals.club);
      // }
      // if (deals.type !== null) {
      //   this.list.monitor = this.list.monitor.filter((item) => item.type.id === deals.type);
      // }
      // if (deals.current_stage !== null) {
      //   this.list.monitor = this.list.monitor.filter((item) => item.current_stage.id === deals.current_stage);
      // }
      // if (deals.manager !== null) {
      //   this.list.monitor = this.list.monitor.filter((item) => item.manager.id === deals.manager);
      // }
      // if (deals.user !== null) {
      //   this.list.monitor = this.list.monitor.filter((item) => item.user.id === deals.user);
      // }
      // if (deals.advertising_source !== null) {
      //   this.list.monitor = this.list.monitor.filter((item) => item.advertising_source.id === deals.advertising_source);
      // }
      // if (deals.tag !== null) {
      //   this.list.monitor = this.list.monitor.filter((item) => item.tag === deals.tag);
      // }
      // if (deals.interests !== null) {
      //   this.list.monitor = this.list.monitor.filter((item) => item.interests === deals.interests);
      // }
      // if (deals.scheduled_task !== null) {
      //   this.list.monitor = this.list.monitor.filter((item) => (item.scheduled_task.length !== 0) === deals.scheduled_task);
      // }
      // if (deals.advertising_platform !== null) {
      //   this.list.monitor = this.list.monitor.filter((item) => item.advertising_platform.id === deals.advertising_platform);
      // }
      // if (deals.deletion !== null) {
      //   this.list.monitor = this.list.monitor.filter((item) => item.deletion === deals.deletion);
      // }
    },
    returnDeals() {
      //if (!this.dialogButton) {
        this.fetchFeed(this.specialist_id, this.type, this.startdate, this.enddate, null, this.dealsFilter);
      //}
    },
    formatDate(date) {
      date = new Date(date);
      const day = date.getDate();
      const month = date.getMonth() + 1;
      const year = date.getFullYear();
      const formattedDay = (day < 10) ? `0${day}` : day;
      const formattedMonth = (month < 10) ? `0${month}` : month;

      return `${formattedDay}.${formattedMonth}.${year}`;
    }
  },
  mounted() {
    console.log(this.specialist_id)
    console.log(this.specialist_ids)
    console.log(this.specialistType)
    console.log(this.startdate)

    //this.isLoading = true

    if(getItem('transactions-filter_obj') && getItem('transactions-filter_obj') !== null && getItem('transactions-filter_obj') !== undefined && getItem('transactions-filter_obj') !== 'null'){

      console.log('yes')
      console.log(getItem('transactions-filter_obj'))

      this.dealsFilter = JSON.parse(getItem('transactions-filter_obj'))

    }
    
    if(this.specialist_id && this.specialist_id !== undefined && this.specialist_id !== null && this.specialist_id !== 'null'){
      setItem('transactions-specialist_id', this.specialist_id)
    } else {
      this.specialist_id = getItem('transactions-specialist_id')
    }

    this.type !== undefined ? setItem('transactions-type', this.type) : this.type = getItem('transactions-type');
    if (this.startdate === undefined && this.enddate === undefined) {
      this.startdate = new Date();
      this.enddate = new Date();
    }
    // if(this.specialistType == 0) {
    //   this.specialist_id = null
    // }

    if(getItem('transactions-specialist_id') && getItem('transactions-specialist_id') !== undefined && getItem('transactions-specialist_id') !== null && getItem('transactions-specialist_id') !== 'null'){

    } else {
      if(!this.specialistType || this.specialistType == 0) {
        this.specialist_id = null
      }
    }

    
    this.$store.dispatch(advertisingActionTypes.getPlatforms)
    this.$store.dispatch(advertisingActionTypes.getSources)
    
    this.$store.dispatch(organizationActionTypes.organizationManagersList).then((response) => {
        if(this.specialist_id) {
            if(response && response.managers){
              let managerDef = response.managers.filter((item) => this.specialist_id.includes(item.id));
              if(managerDef && managerDef[0] && managerDef[0].id){
                this.dealsFilter.manager = {
                  name: managerDef[0].name,
                  id: managerDef[0].id
                }

                this.fetchFeed(this.specialist_id, this.type, this.startdate, this.enddate, this.search, this.dealsFilter);
              } else {
                this.fetchFeed(this.specialist_id, this.type, this.startdate, this.enddate, this.search, this.dealsFilter);
              }
            }
        } else {
          this.fetchFeed(this.specialist_id, this.type, this.startdate, this.enddate, this.search, this.dealsFilter);
        }
    });

    

    this.$store.dispatch(lessonActionTypes.getSpecialistList);
    this.$store.dispatch(tagsActionTypes.tagsList).then((response => {
        if(response.success){
          this.tagsList = response.tags
        }
    }))
  },
  data() {
    return {
      search: '',
      select: null,
      selected: [],
      dialogFiler: false,
      dialogButton: true,
      valid: true,
      dealsFilter: {
        date_creation: null,
        date_end: null,
        date_schedule: {start:this.startdate,end:this.enddate},
        status_deal: {name: 'Не завершена', value: false},
        status_client: null,
        club: {name: 'КлеверСпорт Н.Челны', id: "2dd7fea2-587b-11ea-80e1-9c5c8e747603"},
        current_stage: null,
        manager: null,
        user: null,
        advertising_source: null,
        tag: null,
        interests: null,
        scheduled_task: null,
        advertising_platform: null,
        deletion: {name: 'Не удалена', value: false}
      },
      statusDealTypes: [
        {name: 'Завершена', value: true},
        {name: 'Не завершена', value: false}
      ],
      scheduledTaskTypes: [
        {name: 'Есть задачи', value: true},
        {name: 'Нет задач', value: false}
      ],
      deletionTypes: [
        {name: 'Удалена', value: true},
        {name: 'Не удалена', value: false}
      ],
      clubTypes: [
      {name: 'КлеверСпорт Н.Челны', id: "2dd7fea2-587b-11ea-80e1-9c5c8e747603"}
      ],
      sourceTypes: [
        {name: 'Указан', value: true},
        {name: 'Не указан', value: false}
      ],
      platformTypes: [
        {name: 'Указан', value: true},
        {name: 'Не указан', value: false}
      ],
      statusClientTypes: [
        {name: 'Потенциальный член клуба', value: "ПотенциальныйЧленКлуба"},
        {name: 'Клиент клуба', value: "КлиентКлуба"},
        {name: 'Член клуба', value: "ЧленКлуба"},
        {name: 'Бывший клиент клуба', value: "БывшийКлиентКлуба"},
        {name: 'Бывший член клуба', value: "БывшийЧленКлуба"},
        {name: 'Отказ', value: "Отказ"}
      ],
      stageTypes: [
        {name: 'Отказ', value: "361870a3-f7b5-11ea-8134-9c5c8e747603-0"}, //!
        {name: 'Успех', value: "361870a3-f7b5-11ea-8134-9c5c8e747603-01"}, //!
        {name: 'Контакт с клиентом', value: "361870a3-f7b5-11ea-8134-9c5c8e747603"},
        {name: 'Презентация клуба', value: "361870a4-f7b5-11ea-8134-9c5c8e747603"},
        {name: 'Пробное занятие', value: "361870a6-f7b5-11ea-8134-9c5c8e747603-02"}, //!
        {name: 'Оформление продажи', value: "361870a6-f7b5-11ea-8134-9c5c8e747603"}
      ],
      interestsTypes:[
          {
              "id": "40f7d647-1277-11ee-a065-60e32700ce56",
              "name": "август",
              "flag_deletion": false
          },
          {
              "id": "0a4d935a-a697-11ec-a061-60e32700ce56",
              "name": "акция",
              "flag_deletion": false
          },
          {
              "id": "3007656d-3170-11eb-a05b-60e32700ce56",
              "name": "былтур",
              "flag_deletion": false
          },
          {
              "id": "69ee2112-3246-11eb-a05b-60e32700ce56",
              "name": "былтур",
              "flag_deletion": false
          },
          {
              "id": "d16ce0de-349b-11eb-a05b-60e32700ce56",
              "name": "гэс",
              "flag_deletion": false
          },
          {
              "id": "e2c5e3e7-421b-11f0-a07b-60e32700ce56",
              "name": "другой город",
              "flag_deletion": false
          },
          {
              "id": "045392bd-864b-11eb-a05d-60e32700ce56",
              "name": "замелекесье",
              "flag_deletion": false
          },
          {
              "id": "2bfae752-7f72-11ec-a061-60e32700ce56",
              "name": "не звонить",
              "flag_deletion": false
          },
          {
              "id": "d031e9fb-9195-11ed-a063-60e32700ce56",
              "name": "новый город",
              "flag_deletion": false
          },
          {
              "id": "59acd22a-0459-11ee-a065-60e32700ce56",
              "name": "Осень",
              "flag_deletion": false
          },
          {
              "id": "a163f459-93ee-11ed-a063-60e32700ce56",
              "name": "пенсионе",
              "flag_deletion": false
          },
          {
              "id": "0ca9f0cb-6a68-11ed-a063-60e32700ce56",
              "name": "переезд",
              "flag_deletion": false
          },
          {
              "id": "26a063b7-91af-11ed-a063-60e32700ce56",
              "name": "подумает подойдет",
              "flag_deletion": false
          },
          {
              "id": "88313da1-3534-11eb-a05b-60e32700ce56",
              "name": "розыгрыш НГ",
              "flag_deletion": false
          },
          {
              "id": "064c02e1-c043-11ee-a06c-60e3270104e0",
              "name": "СИБУР",
              "flag_deletion": false
          },
          {
              "id": "09338ea6-2b4a-11f0-a07b-60e32700ce56",
              "name": "список от вайнера ",
              "flag_deletion": false
          },
          {
              "id": "f64ed81e-3fa6-11eb-a05c-60e3270104e0",
              "name": "термо",
              "flag_deletion": false
          },
          {
              "id": "e63bb3ca-122a-11eb-8136-9c5c8e747603",
              "name": "тренажерный зал",
              "flag_deletion": false
          },
          {
              "id": "142e0513-024b-11eb-8136-9c5c8e747603",
              "name": "тур был",
              "flag_deletion": false
          },
          {
              "id": "8743dc7c-0ff0-11ec-a060-60e32700ce56",
              "name": "укрепление здоровья",
              "flag_deletion": false
          },
          {
              "id": "d5bf28f2-f8e9-11ea-8136-9c5c8e747603",
              "name": "хочет сбросить вес",
              "flag_deletion": false
          }
      ],
      headersDeals: [
        {text: 'Клиент', align: 'start', value: 'client.name'},
        {text: 'Сделка', value: 'name'},
        {text: 'Создана', value: 'date_creation'},
        {text: 'Тег', value: 'tag'},
        {text: 'Интересы', value: 'interests'},
        {text: 'Этап, Сумма, Вид сделки', value: 'current_stage.name'},
        {text: 'Рекламный источник, канал', value: 'advertising_platform.name'},
        {text: 'Запланированная задача', value: 'scheduled_task.name'},
        {text: 'Менеджер', value: 'manager.name'},
        {text: 'Структурная еденица', value: 'club.name'},
        {text: 'Кем создан', value: 'user.name'},
        {text: 'Последняя задача', value: 'last_task.name'},
        {text: 'Причина отказа', value: 'cancel_reason.name'}
      ],
      page:1,
      toggle_exclusive: 20,
      tagsList:[]
    }
  },
  watch: {
    toggle_exclusive() {
      console.log(0)
      this.page = 1;
      if (this.search === '') {
        // let page = this.page;
        // let limit = this.toggle_exclusive;
        this.fetchFeed(this.specialist_id, this.type, this.startdate, this.enddate, null, this.dealsFilter);
      }
    },
    page() {
      console.log(1)
      if (this.search === '') {
        // let page = this.page;
        // let limit = this.toggle_exclusive;
        this.fetchFeed(this.specialist_id, this.type, this.startdate, this.enddate, null, this.dealsFilter);
      } else {
        this.fetchFeed(this.specialist_id, this.type, this.startdate, this.enddate, this.search, this.dealsFilter);
      }
    },
    search() {
      console.log(2)
      if (this.search !== '') {
        this.loading = true
        this.specialist_id !== undefined ? setItem('transactions-specialist_id', this.specialist_id) : this.specialist_id = JSON.parse(getItem('transactions-specialist_id'));
        this.type !== undefined ? setItem('transactions-type', this.type) : this.type = getItem('transactions-type');
        if (this.startdate === undefined && this.enddate === undefined) {
          this.startdate = new Date();
          this.enddate = new Date();
        }
        if(this.specialistType == 0) {
          this.specialist_id = null
        }
            this.fetchFeed(this.specialist_id, this.type, this.startdate, this.enddate, this.search, this.dealsFilter);
          } else {
            this.loading = true
            this.specialist_id !== undefined ? setItem('transactions-specialist_id', this.specialist_id) : this.specialist_id = JSON.parse(getItem('transactions-specialist_id'));
        this.type !== undefined ? setItem('transactions-type', this.type) : this.type = getItem('transactions-type');
        if (this.startdate === undefined && this.enddate === undefined) {
          this.startdate = new Date();
          this.enddate = new Date();
        }
        if(this.specialistType == 0) {
          this.specialist_id = null
        }
            this.fetchFeed(this.specialist_id, this.type, this.startdate, this.enddate, null, this.dealsFilter);
          }
      }
  }
}
</script>
<style scoped lang="scss">
.filter {
  padding: 20px;

  .top-line {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .w-352 {
      width: 352px;
    }

    .filter-btn {
      background: #A13453;
      border-radius: 12px;
      text-transform: none;
      color: #FFFFFF;
      font-family: 'Circe';
      font-style: normal;
      font-weight: 700;
      font-size: 16px;
      line-height: 24px;
      box-shadow: none;
      padding: 13px 21px;

      svg {
        margin-right: 5px;
      }
    }

  }

  .hidden-block {
    padding-top: 20px;

  }

  &__field {
    &.colspan-4 {
      grid-column: 1 / 5;
    }

    &.button-block {
      button {
        &:not(:last-child) {
          margin-right: 20px;
        }
      }
    }

    .label {
      color: #1A1A1A;
      display: block;
      margin-bottom: 8px;
      font-family: 'Circe';
      font-style: normal;
      font-weight: 400;
      font-size: 16px;
      line-height: 24px;
    }
  }

  button {
    border-radius: 12px;
    text-transform: none;
    color: #FFFFFF;
    font-family: 'Circe';
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 24px;
    box-shadow: none;
    padding: 13px 21px;

    &.apply {
      background: #629F33 !important;
      color: #fff !important;
    }

    &.clear {
      background: #F1F1F1 !important;
      color: #1A1A1A !important;
    }

  }
}

.min-w-173 {
  min-width: 173px;
}

.client {
  display: flex;
  align-items: center;

  .ava {
    margin-right: 8px;
  }
}

.vd-activator .custom__datepicker {
  width: 87% !important;
  height: 14px !important;
  display: flex !important;
  padding: 12px 16px !important;
  position: relative !important;
  box-sizing: content-box !important;
  align-items: center !important;
  flex-shrink: 0 !important;
  border-color: #E0E0E0 !important;
  border-style: solid !important;
  border-width: 1px !important;
  border-radius: 8px !important;
  justify-content: center !important;
  background-color: #ffffff !important;
  font-size: 14px !important;
  color: #000 !important;
}

.custom__button {
  width: 121px !important;
  height: 38px;
  display: flex;
  gap: 4px;
  padding: 5px 10px;
  position: relative;
  box-sizing: content-box;
  align-items: center;
  flex-shrink: 0;
  border-radius: 12px !important;
  margin-top: 0 !important;
  justify-content: center;
  background-color: #F1F1F1 !important;
  font-size: 16px;
  font-weight: 700;
  color: #1A1A1A !important;
}

.custom__card-title {
  justify-content: space-between;
  flex-wrap: wrap;
}

.search_client {
  min-width: 40%;
  display: flex;
  align-items: center;
}

@media (min-width: 1264px) and (max-width: 1390px) {
  .adaptive-container {
    max-width: 1050px !important;
  }
  .container {
    max-width: 1050px !important;
  }
}

</style>